import React from 'react';

import {MembersRequester} from '../../Domain/Groups/MembersRequester';
import {MemberRow} from '../../Domain/Groups/helpers/MemberRow';

const toMemberItem = (m) => ({
    ...m,
    value: m._id,
    label: [m.FirstName || m.Name, m.LastName].filter(Boolean).join(' ') || m.Email,
});

const renderMemberItem = (item, isChecked, onToggle) => (
    <MemberRow key={item.value} user={item} checked={isChecked} onToggle={onToggle} />
);

const fetchOwnerCandidates = async (workspace, searchStr) => {
    const result = await MembersRequester.getEligibleOwnersForSelect(workspace, {searchStr});
    const members = (result?.data || []).map(toMemberItem);
    return {data: members, totalCount: members.length};
};

const buildOwnerPickerConfig = ({workspace, currentSet, addRef, onSave}) => {
    let fetchedItems = [];
    return {
        anchorEl: addRef.current,
        title: 'Select Owners',
        searchPlaceHolder: 'Search members...',
        isMultipleChoices: true,
        showActionBar: true,
        showSelectedCount: true,
        fetchData: async (skip, limit, searchStr) => {
            const result = await fetchOwnerCandidates(workspace, searchStr);
            fetchedItems = result.data;
            return {...result, initialSelected: [...currentSet]};
        },
        renderItem: renderMemberItem,
        onSave: (selectedIds) => {
            const selectedSet = new Set(selectedIds);
            const selectedMembers = fetchedItems.filter((m) => selectedSet.has(m.value));
            onSave(selectedMembers);
        },
    };
};

export const openOwnerPickerModal = ({workspace, currentOwnerIds, modalStore, addRef, onSave}) => {
    const currentSet = new Set(currentOwnerIds);
    modalStore.modalData.genericSelectData = buildOwnerPickerConfig({workspace, currentSet, addRef, onSave});
    modalStore.isGenericSelectSearchModalOpen = true;
};
